// RoutePermissionWrapper.js - 向下相容的路由權限檢查組件
import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';
import { ROLES } from '../constants/permissions';

/**
 * 管理員路由檢查器 - 向下相容的 Admin 檢查
 * 支援舊的 userRole === 'Admin' 邏輯和新的角色權限檢查
 */
export const AdminRoute = ({ children, userRole, redirectTo = "/dashboard" }) => {
    // 優先使用新的權限系統檢查
    const currentUser = authService.getCurrentUser();
    if (currentUser && currentUser.permissions) {
        const isAdmin = authService.hasRole(ROLES.ADMIN) || authService.hasRole(ROLES.OWNER);
        if (!isAdmin) {
            console.warn('🚫 Admin route access denied via new permission system');
            return <Navigate to={redirectTo} replace />;
        }
        return children;
    }

    // 如果新權限系統沒有資料，回退到舊的角色檢查
    if (userRole !== 'Admin' && userRole !== 'Owner') {
        console.warn(`🚫 Admin route access denied via legacy role check: ${userRole}`);
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

/**
 * 智能權限路由 - 自動選擇最佳的權限檢查方式
 */
export const SmartPermissionRoute = ({
    children,
    // 可以同時支援舊的角色和新的權限
    legacyRole = null,
    userRole = null,
    permissions = [],
    requireAllPermissions = false,
    redirectTo = "/dashboard"
}) => {
    const currentUser = authService.getCurrentUser();

    // 新權限系統：有指定 permissions 且使用者有權限資料時檢查
    if (currentUser && currentUser.permissions && permissions.length > 0) {
        const hasAccess = requireAllPermissions
            ? permissions.every(perm => authService.hasPermission(perm))
            : permissions.some(perm => authService.hasPermission(perm));

        if (hasAccess) {
            return children;
        }
    }

    // 回退到舊的角色檢查
    if (legacyRole && userRole === legacyRole) {
        return children;
    }

    // Fail-closed：兩種檢查都沒通過（或條件不足以判斷）一律拒絕
    console.warn(`🚫 Smart route access denied. Required permissions: [${permissions.join(', ')}], required role: ${legacyRole}, user role: ${userRole}`);
    return <Navigate to={redirectTo} replace />;
};

export default { AdminRoute, SmartPermissionRoute };